// extracted by mini-css-extract-plugin
export var featuredPages = "index-module--featuredPages--JLvha";
export var hero = "index-module--hero--Rse9T";
export var heroImage = "index-module--heroImage--+SIJ7";
export var latestPages = "index-module--latestPages--wvj+u";
export var listPages = "index-module--listPages--fotfZ";